import {
	Toast
} from 'vant';
import storePage from '@/store/page';

/*
 * 防抖
 * fn：传入的函数
 * delay：延迟时间
 * context：this指向
 * args：参数
 */
export const debounce = (fn, delay = 400) => {
	let timer = null
	return (context, ...args) => {
		clearTimeout(timer)
		timer = setTimeout(() => {
			fn.apply(context, args)
		}, delay)
	}
}

/*
 * 复制到剪切板
 * value：复制的值
 * isTip: 是否提示复制成功
 */
export const copy = (value, isTip = true) => {
	const box = document.createElement('div');
	let transfer = document.createElement('input');
	// 解决复制时出现页面滚动到底部的问题
	box.style.position = 'absolute'
	box.style.top = 0
	box.style.left = 0
	box.style.width = '100%'
	box.style.height = '100%'
	transfer.style.position = 'absolute'
	transfer.style.top = 0
	transfer.style.left = 0

	document.body.appendChild(box);
	box.appendChild(transfer);
	transfer.value = value; // 这里表示想要复制的内容
	transfer.focus();
	transfer.select();
	if (document.execCommand('copy')) {
		document.execCommand('copy');
	}
	transfer.blur();
	document.body.removeChild(box);

	if (isTip) Toast.success('复制成功')
}

/*
 * 获取路由名称
 */
export const getPathname = () => {
	let pathname = location.pathname.substring(1)
	return decodeURIComponent(pathname)
}

/*
 * 判断来源设备（安卓：1、ios：2、pc：3）
 */
export const getEquipment = () => {
	const {
		equipmentInfo
	} = storePage.state;
	if (equipmentInfo.android) return 1
	if (equipmentInfo.ios) return 2
	if (equipmentInfo.pc) return 3
}

/*
 * 判断当前设备的来源平台
 */
export const getPlatform = () => {
	if (getEquipment() === 3) return 0 // pc端则直接输出 未知

	const {
		browserInfo
	} = storePage.state;
	const keyToType = {
		'douyin': 1,
		'kuaishou': 2,
		'zhihu': 3,
		'weibo': 4,
		'bilibili': 5,
		'xiaohongshu': 6,
		'taobao': 7,
		'toutiao': 8,
		'ximalaya': 9,
		'weiXin': 10,
		'QQ': 11,
	}
	for (let key in keyToType) {
		if (browserInfo[key]) return keyToType[key]
	}

	return 0 // 未知
}
//获取时间格式
export const get_time = (format, time, type) => {
	const data = new Date(time * 1000)
	//
	format = format.replace('Y', data.getFullYear())
	if (!type) {
		format = format.replace('m', ((data.getMonth() + 1) + '').padStart(2, '0'))
		format = format.replace('d', (data.getDate() + '').padStart(2, '0'))
		format = format.replace('H', (data.getHours() + '').padStart(2, '0'))
		format = format.replace('i', (data.getMinutes() + '').padStart(2, '0'))
		format = format.replace('s', (data.getSeconds() + '').padStart(2, '0'))
	} else {
		format = format.replace('m', ((data.getMonth() + 1) + ''))
		format = format.replace('d', (data.getDate() + ''))
		format = format.replace('H', (data.getHours() + ''))
		format = format.replace('i', (data.getMinutes() + ''))
		format = format.replace('s', (data.getSeconds() + ''))
	}
	return format
}

// 判断是否是微信浏览器环境
export const env_is_wexin = () => {
	var ua = navigator.userAgent.toLowerCase();
	if (ua.match(/MicroMessenger/i) == "micromessenger") {
		return true;
	}
	return false;
}

export const formatMoney = (s, n) => {
	n = n >= 0 && n <= 20 ? n : 2;
	s = parseFloat((s + '').replace(/[^\d\.-]/g, '')).toFixed(n) + '';
	var l = s.split('.')[0].split('').reverse(),
		r = s.split('.')[1];
	var t = '';

	for (let i = 0; i < l.length; i++) {
		t += l[i] + ((i + 1) % 3 == 0 && i + 1 != l.length ? ',' : '');
	}

	return t.split('').reverse().join('') + (n ? '.' + r : '');
};



// 用于安卓/ios端的交互
function router_link (key, value) {
	console.log(value,11)
    if (/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)) {
        window.webkit.messageHandlers[key].postMessage(value)
    } else {
        window.jsProduct && window.jsProduct[key] && window.jsProduct[key](value)
    }
}

export const toapp = function (index, item) {
    // closePage: 关闭app
    // sharePageCard: 分享卡片
    // pay: 调起app内的支付
    // transfer: 分享转让的数字文创/空间
    // house: 跳转小游戏数字空间
    // login: 跳转app登录界面
    // skipPage: 跳转指定路径（路径地址需为完整路径）
    // intoDetail: 跳转nft详情页
	//jumpMiniProgram:跳转小程序
	//console.log(item,"toapp")
	console.log(item,"toapp",index)
    const arr = ['closePage', 'sharePageCard', 'pay', 'transfer', 'house', 'login', 'skipPage', 'intoDetail','jumpMiniProgram']
    router_link(arr[index - 1], item || '')
}
